import { T, useTheme, dens, Card, Eyebrow } from '../../../design';
import { fmtCount } from '../../../utils';
import { ACCENT_SOFT } from '../primeStatsConfig';
import type { StatsTotals } from '../../../types/primeStats.types';

export function SplitBar({ primary, family, height = 10 }: { primary: number; family: number; height?: number }) {
  const t = useTheme();
  const tot = Math.max(1, primary + family);
  const pp = (primary / tot) * 100;
  return (
    <div style={{ display: 'flex', height, borderRadius: 999, overflow: 'hidden', background: T.track }}>
      <div style={{ width: `${pp}%`, background: t.accent }} />
      <div style={{ width: `${100 - pp}%`, background: ACCENT_SOFT }} />
    </div>
  );
}

export function LegendDot({ color, label, value }: { color: string; label: string; value: string }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
      <span style={{ width: 9, height: 9, borderRadius: 3, background: color, flexShrink: 0 }} />
      <span style={{ fontSize: 12, color: T.fg2, fontWeight: 600 }}>{label}</span>
      <span style={{ fontSize: 12, color: T.fg, fontWeight: 800, marginLeft: 2 }}>{value}</span>
    </div>
  );
}

export function StatHero({ eyebrow, totals }: { eyebrow: string; totals: StatsTotals }) {
  const t = useTheme();
  const d = dens(t);
  return (
    <Card pad={d.pad}>
      <Eyebrow>{eyebrow}</Eyebrow>
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 10, margin: '8px 0 14px' }}>
        <div style={{ fontSize: 52, fontWeight: 800, letterSpacing: '-0.03em', lineHeight: 0.95, color: T.fg }}>{fmtCount(totals.total)}</div>
        <div style={{ fontSize: 12, fontWeight: 600, color: T.fg3, paddingBottom: 8 }}>medlemmer</div>
      </div>
      <SplitBar primary={totals.primary} family={totals.family} />
      <div style={{ display: 'flex', gap: 18, marginTop: 12 }}>
        <LegendDot color={t.accent} label="Hovedmedlem" value={fmtCount(totals.primary)} />
        <LegendDot color={ACCENT_SOFT} label="Familiemedlem" value={fmtCount(totals.family)} />
      </div>
    </Card>
  );
}
